import React from "react";
import { useQueryParams } from "lib/hooks/useQueryParams";
import { _t } from "app/i18n/i18n";
import QueryString from "query-string";
import { useLocation } from "react-router";
import { Pills, PillsFromFilter } from "./Pills";
import { ClearFiltersButton } from "./ClearFiltersButton";
import SubscriptionsButton from "../../../../components/Subscriptions/SubscriptionsButton/SubscriptionsButton";
import { features } from "../../../../app/features";

export function PillsBar({ persistentContent }) {
  const persistentQs = QueryString.parse(persistentContent);
  const qs = useQueryParams();
  const { pathname } = useLocation();
  const pathNameArray = pathname.split("/");
  const isLandingPage = pathNameArray?.[1]?.toLowerCase() === "topics";
  const pills = PillsFromFilter(qs);
  const persistentPills = PillsFromFilter(persistentQs);

  if (pathname !== "/Home") {
    if (!isLandingPage) {
      const asset = pathname.substring(1);
      pills.unshift({ category: "route", text: _t(asset) });
    }
  }

  if (!pills?.length && !persistentPills?.length) return null;

  return (
    <section className="d-flex border mb-2">
      <span className="pl-2 text-muted small d-sm-block d-none align-self-center">{_t("Filters:")} </span>
      <div className="flex-grow-1 line-height-25 p-2">
        <Pills pills={persistentPills} persistent />
        <Pills pills={pills} />
      </div>
      {features.subscriptionButton && !isLandingPage && (
        <div className="pills-bar-subscribe" style={{ display: "flex", alignItems: "center", alignSelf: "center" }}>
          <SubscriptionsButton isFromPillsBar />
        </div>
      )}
      <ClearFiltersButton />
    </section>
  );
}
